import { useLayoutEffect } from "react";
import Auth from "../libs/vendors/auth";

export const useAuthInit = (): void => {
    useLayoutEffect(() => {
        Auth.init();
    }, []);
};
